import { useEffect } from "react";
import { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import * as APIModels from "../../../../models";
import { CaseTypeRulesService } from "../../../../services/ClientService";
import React from "react";

export type CaseTypeRuleModalProps = {
    show: boolean;
    attorneyId: string;
    county?: string;
    division?: string;
    csvCaseType: string;
    csvSubCaseType: string;
    efmeCaseType: string;
    caseType: string;
    caseSubType: string;
    ruleId?: string;
    onSave: () => void;
    onClose: () => void;
};

export default function CaseTypeRuleModal({
    show,
    attorneyId,
    county,
    division,
    csvCaseType,
    csvSubCaseType,
    efmeCaseType,
    caseType,
    caseSubType,
    ruleId,
    onSave,
    onClose,
}: CaseTypeRuleModalProps) {
    const [rule, setRule] = useState({
        id: ruleId,
        attorneyID: attorneyId,
        county: county,
        division: division,
        efmeCaseType: efmeCaseType,
        caseType: caseType,
        csvCaseType: csvCaseType,
        csvSubCaseType: csvSubCaseType,
        caseSubType: caseSubType,
    } as APIModels.CaseTypeRule);

    useEffect(() => {
        console.log("rule " + JSON.stringify(rule));
    }, []);

    useEffect(() => {
        setRule({
            id: ruleId,
            attorneyID: attorneyId,
            county: county,
            division: division,
            efmeCaseType: efmeCaseType,
            csvSubCaseType: csvSubCaseType,
            caseType: caseType,
            csvCaseType: csvCaseType,
            caseSubType: caseSubType,
        });
    }, [
        show,
        attorneyId,
        county,
        division,
        ruleId,
        efmeCaseType,
        caseType,
        caseSubType,
        csvSubCaseType,
        csvCaseType,
    ]);

    const saveRule = () => {
        if (!rule.id || rule.id == APIModels.EmptyGuid) {
            CaseTypeRulesService.add({
                body: {
                    ...rule,
                    active: true,
                },
            }).then(
                (resp) => {
                    onSave();
                },
                (error) => {
                    console.log(error);
                }
            );
        } else {
            CaseTypeRulesService.update({
                id: rule?.id ?? "",
                body: rule,
            }).then(
                (resp) => {
                    onSave();
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    };

    return (
        <Modal
            show={show}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    Case Type Rule
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row form-group m-2">
                    <div className="col-sm-6">
                        <label>County</label>
                        <input
                            className="form-control"
                            id="docTypeRuleCounty"
                            type="text"
                            defaultValue={rule.county}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    county: event.currentTarget.value,
                                })
                            }
                        />
                    </div>
                    <div className="col-sm-6">
                        <label>Division</label>
                        <input
                            className="form-control"
                            id="docTypeRuleDivision"
                            type="text"
                            defaultValue={rule.division}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    division: event.currentTarget.value,
                                })
                            }
                        />
                    </div>
                </div>

                <div className="row form-group m-2">
                    <div className="col-sm-12">
                        <label>csvCaseType</label>
                        <input
                            className="form-control"
                            id="docTypeRuleFilename"
                            type="text"
                            defaultValue={rule.csvCaseType}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    csvCaseType: event.currentTarget.value,
                                })
                            }
                        />
                    </div>
                </div>

                <div className="row form-group m-2">
                    <div className="col-sm-12">
                        <label>csvCaseSubType</label>
                        <input
                            className="form-control"
                            id="docTypeRuleFileText"
                            type="text"
                            defaultValue={rule.csvSubCaseType}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    csvSubCaseType: event.currentTarget.value,
                                })
                            }
                        />
                    </div>
                </div>

                <div className="row form-group m-2">
                    <div className="col-sm-3">
                        <label>Min Amount</label>
                        <input
                            className="form-control"
                            id="docTypeRuleMinAmount"
                            type="number"
                            defaultValue={0}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    minAmount: parseFloat(
                                        event.currentTarget.value
                                    ),
                                })
                            }
                        />
                    </div>
                    <div className="col-sm-3">
                        <label>Max Amount</label>
                        <input
                            className="form-control"
                            id="docTypeRuleMaxAmount"
                            type="number"
                            defaultValue={0}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    maxAmount: parseFloat(
                                        event.currentTarget.value
                                    ),
                                })
                            }
                        />
                    </div>
                </div>
                <div className="row form-group m-2">
                    <div className="col-sm-12">
                        <label>efmeCaseType</label>
                        <input
                            className="form-control"
                            id="docTypeRuleDocType"
                            type="text"
                            defaultValue={rule.efmeCaseType}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    efmeCaseType: event.currentTarget.value,
                                })
                            }
                        />
                    </div>
                </div>
                <div className="row form-group  m-2">
                    <div className="col-sm-12">
                        <label>caseType</label>
                        <input
                            className="form-control"
                            id="docTypeRuleUntil"
                            type="text"
                            defaultValue={rule.caseType}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    caseType: event.currentTarget.value,
                                })
                            }
                        />
                    </div>
                </div>
                <div className="row form-group  m-2">
                    <div className="col-sm-12">
                        <label>caseSubType</label>
                        <input
                            className="form-control"
                            id="docTypeRuleUntil"
                            type="text"
                            defaultValue={rule.caseSubType}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    caseSubType: event.currentTarget.value,
                                })
                            }
                        />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button className="btn-danger" onClick={onClose}>
                    Cancel
                </Button>
                <Button onClick={saveRule}>Save</Button>
            </Modal.Footer>
        </Modal>
    );
}
